export class FleetConstantClassCollection {
    fleetStateList?: string[];
    fleetKindList?: string[];
    fleetTypeList?: string[];
    fleetInstanceTypeList?: string[];
    fleetAccessPolicyList?: string[];
}